import {Component, OnInit, Inject, OnDestroy} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar} from '@angular/material';
import { UserService } from '@user/user.service';
import { Subject } from 'rxjs';
import { IDialogSearch, IUser } from '@base/interfaces';

@Component({
  selector: 'app-search-users',
  templateUrl: './search-users.component.html',
  styleUrls: ['./search-users.component.sass']
})

export class SearchUsersComponent implements OnInit, OnDestroy {
  searchTerm$ = new Subject<string>();
  searching = false;
  queryParams: object = null;
  collection = [];

  constructor(
    public dialogRef: MatDialogRef<SearchUsersComponent>,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: IDialogSearch
  ) {
    this.queryParams = {
      ordering: 'first_name',
      role__code: data.subject,
      page: 1,
      page_size: 100,
      search: ''
    };

    this.userService.search(this.searchTerm$, this.queryParams).subscribe(
      (results: Array<any>) => {
        this.dataAdapter(results);
      },
      err => {
        console.log(err.message);
        this.searching = false;
      }
    );
  }

  ngOnInit() { }
  ngOnDestroy() { }

  search(term: string) {
    if (term.trim().length) {
      this.searching = true;
      this.searchTerm$.next(term);
    }
  }

  private dataAdapter(dataset) {
    this.collection = dataset;
  }

  loginAs(user: IUser) {
    this.dialogRef.close({action: 'login_as', user: user});
  }

  swStatus(user: IUser, newStatus: boolean) {
    this.dialogRef.close({action: 'change_status', user: user, newStatus: newStatus});
  }

  editRow(user: IUser) {
    this.dialogRef.close({action: 'edit', user: user});
  }

  deleteUser(user: IUser) {
    this.dialogRef.close({action: 'delete', user: user});
  }
}
